// extracted by mini-css-extract-plugin
export default {"Body":"_Body--logTH","BodyContainer":"_BodyContainer--kv5PM","Confirm":"_Confirm--A0eFz","TryAgainButtonContainer":"_TryAgainButtonContainer--axUlE"};